/** An organization slug: lowercase letters, digits and inner hyphens, 3 to 50
 *  characters, the shape the database's `organizations_slug_check` enforces. */
export const PORTAL_SLUG_RE = /^[a-z0-9][a-z0-9-]{1,48}[a-z0-9]$/;

const PORTAL_PATH_RE = /^\/portal\/([^/]+)(?:\/|$)/;

export function isPortalSlug(value: unknown): value is string {
  return typeof value === "string" && PORTAL_SLUG_RE.test(value);
}

/** The raw first segment of `/portal/<segment>` or of any page under it, as the
 *  path spells it (malformed or percent-encoded included, never decoded or
 *  validated), or null when the path is not a portal page. */
export function portalSegmentFromPath(pathname: string): string | null {
  return PORTAL_PATH_RE.exec(pathname)?.[1] ?? null;
}

/** The slug of `/portal/<slug>` or of any page under it, or null when the path
 *  is not a portal page or its slug is malformed. */
export function portalSlugFromPath(pathname: string): string | null {
  const slug = portalSegmentFromPath(pathname);
  return isPortalSlug(slug) ? slug : null;
}
